import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import api from 'api';
import { GeneralSuggestedAction } from 'models/SuggestedActions';
import SuggestedActionItemWrapper from 'components/SuggestedActionItemWrapper';
import useGeneralThreeDotsOptions from '../../hooks/useGeneralThreeDotsOptions';
import {
  GENERAL_ACTIONED_ACTION,
  GENERAL_ACTIONED_NAME,
  GENERAL_SUGGESTION_COLOR,
  GENERAL_SUGGESTION_CTA,
  GENERAL_SUGGESTION_DESCRIPTION,
  GENERAL_SUGGESTION_ICON,
  GENERAL_SUGGESTION_ROUTE,
  GENERAL_SUGGESTION_TITLE,
} from '../../generalSuggestedActionsData';

type GeneralSuggestedActionItemProps = {
  className?: string;
  suggestion: GeneralSuggestedAction;
};

const GeneralSuggestedActionItem: React.FC<GeneralSuggestedActionItemProps> = (
  props,
) => {
  const { className, suggestion } = props;

  const { type } = suggestion;

  const { t } = useTranslation();

  const navigate = useNavigate();

  const Icon = GENERAL_SUGGESTION_ICON[type];
  const color = GENERAL_SUGGESTION_COLOR[type];

  const { isMuting, threeDotsOptions } = useGeneralThreeDotsOptions(suggestion);

  const onAction = useCallback(() => {
    api.userSuggestedActions.actionedGeneralSuggestedAction(type, {
      suggestionName: GENERAL_ACTIONED_NAME[type],
      suggestionAction: GENERAL_ACTIONED_ACTION[type],
    });

    navigate(GENERAL_SUGGESTION_ROUTE[type]);
  }, [navigate, type]);

  const classes = classNames(
    'enterprise-suggested-action-item',
    { loading: isMuting },
    className,
  );

  return (
    <SuggestedActionItemWrapper
      className={classes}
      icon={
        <span className={classNames('suggested-action-icon', color)}>
          <Icon />
        </span>
      }
      title={t(GENERAL_SUGGESTION_TITLE[type])}
      description={t(GENERAL_SUGGESTION_DESCRIPTION[type])}
      threeDotsOptions={threeDotsOptions}
      buttonContent={t(GENERAL_SUGGESTION_CTA[type])}
      onButtonClick={onAction}
    />
  );
};

export default GeneralSuggestedActionItem;
